import TagBadge from "@/components/base/TagBadge";
import type { Article } from "@/lib/news";

interface ArticleContentProps {
  article: Article;
}

export default function ArticleContent({ article }: ArticleContentProps) {
  return (
    <div className="mt-6">
      <div className="space-y-5">
        {article.content.map((block, index) => {
          const text = block.trim();
          if (text.startsWith("## ")) {
            return (
              <h2
                key={index}
                className="mt-8 border-l-4 border-accent-500 pl-3 font-heading text-lg font-semibold text-foreground-950 md:text-xl"
              >
                {text.replace("## ", "")}
              </h2>
            );
          }
          const isNote = text.includes("演示示例内容");
          return (
            <p
              key={index}
              className={
                isNote
                  ? "rounded-md bg-background-100 px-4 py-3 text-xs leading-6 text-foreground-400"
                  : "text-[15px] leading-8 text-foreground-800 md:text-base"
              }
            >
              {text}
            </p>
          );
        })}
      </div>

      {article.tags.length > 0 && (
        <div className="mt-8 flex flex-wrap items-center gap-2 border-t border-background-200 pt-6">
          <span className="text-xs text-foreground-500">相关标签：</span>
          {article.tags.map((tag) => (
            <TagBadge key={tag} label={tag} tone="accent" />
          ))}
        </div>
      )}
    </div>
  );
}